import { render, staticRenderFns } from "./MarkSheetTable.vue?vue&type=template&id=07a6b1a4&scoped=true&"
import script from "./MarkSheetTable.vue?vue&type=script&lang=js&"
export * from "./MarkSheetTable.vue?vue&type=script&lang=js&"
import style0 from "./MarkSheetTable.vue?vue&type=style&index=0&id=07a6b1a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a6b1a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VContainer,VDataTable})
